import { useDispatch, useSelector } from 'react-redux';
import { IconMap } from '../../../../../shared/sprite';
import { IntegrationItem } from '../../../../../shared/ui';
import { teamsModel } from '../../../../../features/teams';
import { integrationsModel } from '../../../../../entities/integrations';
import { useState } from 'react';
import { HubspotDetailsModal } from './HubspotDetailsModal';
import { HubspotSettingsModal } from './HubspotSettingsModal';

export const HubspotIntegration: React.FC = () => {
  const dispatch = useDispatch();

  const currentTeam = useSelector(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  const { isHubspotConnected } = currentTeam;

  const isConnectingToHubspot = useSelector(
    integrationsModel.selectors.selectIsConnectingToHubspot
  );

  const isDisconnectingFromHubspot = useSelector(
    integrationsModel.selectors.selectIsDisconnectingFromHubspot
  );

  const handleConnect = () => {
    if (currentTeam.teamConfig.isEnterprise) {
      dispatch(
        integrationsModel.actions.connectToHubspot({
          cb: () => setDetailsModalOpen(false),
        })
      );
    } else {
      dispatch(integrationsModel.actions.setIsEnterpriseOnlyModalOpen(true));
    }
  };

  const handleDisconnect = () => {
    dispatch(integrationsModel.actions.revokeHubspotToken());
  };

  const [isSettingsModalOpen, setSettingsModalOpen] = useState(false);
  const [isDetailsModalOpen, setDetailsModalOpen] = useState(false);

  return (
    <>
      <HubspotDetailsModal
        isOpen={isDetailsModalOpen}
        onClose={() => setDetailsModalOpen(false)}
      />
      <HubspotSettingsModal
        isOpen={isSettingsModalOpen}
        onClose={() => setSettingsModalOpen(false)}
      />
      <IntegrationItem
        icon={IconMap.Hubspot}
        title="HubSpot"
        description="Hubspot is an all-in-one marketing, sales, and service software that
helps businesses grow their audience and increase conversions."
        buttonText={isHubspotConnected ? 'Disconnect' : 'Connect'}
        onClick={isHubspotConnected ? handleDisconnect : handleConnect}
        isDisconnect={isHubspotConnected}
        hasSecondaryBtn
        isLoading={isConnectingToHubspot || isDisconnectingFromHubspot}
        secondaryButtonVariant={isHubspotConnected ? 'icon-text' : 'text'}
        secondaryIcon={isHubspotConnected ? IconMap.Settings01 : undefined}
        secondaryButtonText={isHubspotConnected ? 'Settings' : 'Learn more'}
        onSecondaryBtnClick={() =>
          isHubspotConnected
            ? setSettingsModalOpen(true)
            : setDetailsModalOpen(true)
        }
      />
    </>
  );
};
